import React, { Component } from 'react';
import { ScheduleTable } from './ScheduleTable';
import Dropdown from 'rc-dropdown';
import Menu, { Item as MenuItem, Divider } from 'rc-menu';
import 'rc-dropdown/assets/index.css';

export class Schedule extends Component {

    constructor(props) {
        super(props);
        this.state = { nflWeek: [], loading: true, week: 1,weekId : 0 };
        this.onSelect = this.onSelect.bind(this);
    }

    componentDidMount() {
        this.getWeek(this.state.week);
    }

    menuCallback = () => (
        <Menu onSelect={this.onSelect}>
          <MenuItem key="1">1</MenuItem><Divider />
            <MenuItem key="2">2</MenuItem><Divider />
            <MenuItem key="3">3</MenuItem> <Divider />
            <MenuItem key="4">4</MenuItem> <Divider />
            <MenuItem key="5">5</MenuItem> <Divider />
            <MenuItem key="6">6</MenuItem> <Divider />
            <MenuItem key="7">7</MenuItem> <Divider />
            <MenuItem key="8">8</MenuItem> <Divider />
            <MenuItem key="9">9</MenuItem> <Divider />
            <MenuItem key="10">10</MenuItem> <Divider />
            <MenuItem key="11">11</MenuItem> <Divider />
            <MenuItem key="12">12</MenuItem> <Divider />
            <MenuItem key="13">13</MenuItem> <Divider />
            <MenuItem key="14">14</MenuItem> <Divider />
            <MenuItem key="15">15</MenuItem> <Divider />
            <MenuItem key="16">16</MenuItem> <Divider />
            <MenuItem key="17">17</MenuItem> <Divider />
          <MenuItem key="18">18</MenuItem>
        </Menu>
      );

    onVisibleChange(visible) {
        console.log(visible);
      }

    onSelect({ key }) {
        this.setState({loading: true , week:key });
          this.getWeek(key);
      }

    renderSchedule(scheduleData,weekNum,weekId) {
        return (
            <div>
                <ScheduleTable data={scheduleData} week={weekNum} weekId={weekId} />
            </div>
        );
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderSchedule(this.state.nflWeek,this.state.week,this.state.weekId);

        return (
            <div>
                <div className="scheduleHeader">NFL Schedule Week <span>{this.state.week}</span>
                    <Dropdown
                        trigger={['click']}
                        overlay={this.menuCallback}
                        animation="slide-up"
                        onVisibleChange={this.onVisibleChange}
                    >
                        <button className="weekButton" style={{ width: 100 }}>Week</button>
                    </Dropdown>
                </div>
                {contents}
                <br />
                <br />
            </div>
        );
    }

    async getWeek(week) {
        const response = await fetch(`nflschedule/?weeknum=${week}`);
        const data = await response.json();

       
        let firstGameOfWeek = data.gameid;
        let weekNum ='';

        if(firstGameOfWeek.length >5){
            weekNum = parseInt(firstGameOfWeek.slice(-2));
        }
        else{
            weekNum = parseInt(firstGameOfWeek.slice(-1));
        }
      
        this.setState({ week: weekNum });
        this.setState({ nflWeek: data.nflGameList, loading: false, weekId: data.id });
    }
}